import React, { useState, useEffect } from "react";
import { Image, Col, Row, Button, Form } from "react-bootstrap";
import { TextField, FormControl, Select } from "@material-ui/core";
import Switch from "react-switch";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useFormik } from "formik";
import * as yup from "yup";
import moment from "moment";
import axios from "axios";
import { serverApi, videoUploadSize } from "../../../../config/Keys";
import Alert from "react-s-alert";
import { useHistory } from "react-router-dom";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { Toggle } from "../../../superAdminComponents/superAdminReusable/reusableSuperAdminButton/Toggle";
import { PopupActionButton } from "../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { vendor_update_events } from "../../../../store/actions/vendorOffersAndEventsAction";

const validationSchema = yup.object({
  name: yup
    .string()
    .required("Event name is required")
    .min(1, "Minimum 1 Character")
    .max(64, "Maximum 64 Character"),
  description: yup
    .string()
    .required("Description is required")
    .min(1, "Minimum 1 Character")
    .max(512, "Maximum 512 Character"),
  start_date: yup.string().required("Start date is required"),
  start_time: yup.string().required("Start time is required"),
  end_date: yup.string().required("End date is required"),
  end_time: yup.string().required("End time is required"),
  eventLink: yup
    .string()
    .matches(
      /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
      "Url is invalid"
    )
    .required("Please enter url"),

  terms_and_condition: yup
    .string()
    .required("Terms and condtion  is required")
    .min(1, "Minimum 1 Character")
    .max(512, "Maximum 512 Character"),
});

const MobileVendorEditOnlineEvent = (props) => {
  //state
  const [state, setState] = useState({
    open: false,
    minAge: 18,
  });
  const onOpenModal = () => {
    setState({
      open: true,
    });
  };
  const onCloseModal = () => {
    setState({
      open: false,
    });
  };
  let history = useHistory();
  const [loading, setLoading] = useState();
  const [checked, setChecked] = useState(false);
  const [file, setFile] = useState(null);
  const [Video, setVideo] = useState(null);
  const [primaryOffer, setPrimaryOffer] = useState({ primaryOffer: false });
  const markAsPrimary = (e) => {
    setPrimaryOffer({ primaryOffer: !primaryOffer.primaryOffer });
  };
  const selecthandleChange = (e) => {
    setState({ [e.target.name]: e.target.value });
  };
  const toggleFunction = (e) => {
    setChecked({ checked: !checked.checked });
  };

  const uploadImage = (e) => {
    const data = new FormData();
    data.append("files", e.target.files[0]);
    //setFile(URL.createObjectURL(e.target.files[0]));

    axios
      .post(`${serverApi}/upload-assets?uploadSide=OfflineOffer`, data, {
        headers: {
          "content-type": "multipart/form-data",
        },
      })
      .then((res) => {
        setFile(res.data[0]);
        //formik.setFieldValue("photos", res.data[0]);
        formik.setFieldValue(`photos[0]`, res.data[0]);
      })
      .catch((err) => {
        Alert.error(`<h4>Error while uploading the image</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      });
  };

  const removeImage = () => {
    setFile(null);
    formik.setFieldValue("photos", []);
  };

  const uploadVideo = (e) => {
    if (e.target.files[0]) {
      if (e.target.files[0].size > videoUploadSize) {
        alert("File is too Big");
      } else {
        setLoading(true);
        const data = new FormData();
        data.append("file", e.target.files[0]);
        axios
          .post(`${serverApi}/upload-assets-video`, data, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            setLoading(false);
            Alert.success(`<h4>Video uploaded sucessfully</h4>`, {
              position: "top-right",
              effect: "bouncyflip",
              beep: true,
              html: true,
              timeout: 3000,
              offset: 35,
            });

            setVideo(res.data);
            //formik.setFieldValue("photos", res.data[0]);
            formik.setFieldValue(`videos[0]`, res.data);
          })
          .catch((err) => {
            Alert.error(`<h4>Error while uploading the video</h4>`, {
              position: "top-right",
              effect: "bouncyflip",
              beep: true,
              html: true,
              timeout: 3000,
              offset: 35,
            });
          });
      }
    }
  };
  const removeVideo = () => {
    setVideo(null);
    formik.setFieldValue(`videos[0]`, "");
  };

  useEffect(() => {
    if (history.location && history.location.state) {
      setEditData(history.location.state.editData);
    }
  }, [history.location && history.location.state]);

  const [editData, setEditData] = useState({});
  console.log(editData);

  useEffect(() => {
    if (editData.name) {
      formik.setFieldValue("name", editData.name);
    }
    if (editData.description) {
      formik.setFieldValue("description", editData.description);
    }
    if (editData.coupon_code) {
      formik.setFieldValue("coupon_code", editData.coupon_code);
    }
    if (editData.terms_and_condition) {
      formik.setFieldValue("terms_and_condition", editData.terms_and_condition);
    }
    if (editData && editData.photos && editData.photos.length > 0) {
      setFile(editData.photos[0]);
      formik.setFieldValue(`photos[0]`, editData.photos[0]);
    }

    // if (editData && editData.videos && editData.videos.length > 0) {
    //   setVideo(editData.videos[0]);
    //   formik.setFieldValue(`videos[0]`, editData.videos[0]);
    // }

    if (editData.mark_as_primary) {
      setPrimaryOffer({ primaryOffer: editData.mark_as_primary });
    }

    if (editData.start_date) {
      let startD = editData.start_date.split("T")[0];
      formik.setFieldValue(`start_date`, startD);

      let startT = moment(editData.start_date).format("HH:mm");
      formik.setFieldValue(`start_time`, startT);
    }

    if (editData.end_date) {
      let endD = editData.end_date.split("T")[0];
      formik.setFieldValue(`end_date`, endD);
      let endT = moment(editData.end_date).format("HH:mm");

      formik.setFieldValue(`end_time`, endT);
    }

    // if (editData.active) {
    //   setActive({ active: editData.active });
    // }
  }, [editData]);

  const formik = useFormik({
    initialValues: {
      name: "",
      description: "",
      mark_as_primary: false,
      start_date: "",
      start_time: "",
      end_date: "",
      end_time: "",
      isKidsAllowed: false,
      //minAge: 18,
      //vendor_id: "5f8ac1f8c0aac52d42af60a8",
      isOnline: true,
      eventLink: "",
      eventPassword: "",
      photos: [],
      videos: [],
      terms_and_condition: "",
    },
    validationSchema,

    onSubmit: (values) => {
      const startDate = {
        start_date: moment(
          values.start_date + "T" + values.start_time
        ).toISOString(),
      };
      const end_Date = {
        end_date: moment(values.end_date + "T" + values.end_time).toISOString(),
      };

      values.start_date = startDate.start_date;
      values.end_date = end_Date.end_date;
      delete values["start_time"];
      delete values["end_time"];
      values.vendor_id = props.auth.user.VendorUser._id;

      if (checked.checked) {
        values.isKidsAllowed = true;
        values.minAge = state.minAge;
      }

      if (primaryOffer.primaryOffer) {
        values.mark_as_primary = true;
      }
    },
  });

  const [minDate, setMinDate] = useState("");
  const [minEndDate, setMinEndDate] = useState("");
  const handleStartDateChange = (e) => {
    formik.setFieldValue("start_date", e.target.value);
    formik.setFieldValue("end_date", "");
    setMinEndDate(e.target.value);
  };
  useEffect(() => {
    let data = moment().format("YYYY-MM-DD");
    setMinDate(data);
  }, []);

  const [count, setCount] = useState(1);
  const onClickSave = () => {
    setCount(count + 1);
    formik.handleSubmit();
  };

  // useEffect(() => {
  //   formik.setFieldValue("name", "");
  // }, []);

  useEffect(() => {
    if (formik.errors && formik.errors.name) {
      let nameElement = document.getElementById("name");
      nameElement.focus();
    } else if (formik.errors && formik.errors.description) {
      let descElement = document.getElementById("description");
      descElement.focus();
    } else if (formik.errors && formik.errors.start_date) {
      let startDateElement = document.getElementById("start_date");
      startDateElement.focus();
    } else if (formik.errors && formik.errors.start_time) {
      let startTimeElement = document.getElementById("start_time");
      startTimeElement.focus();
    } else if (formik.errors && formik.errors.end_time) {
      let endDateElement = document.getElementById("end_time");
      endDateElement.focus();
    } else if (formik.errors && formik.errors.end_date) {
      let endTimeElement = document.getElementById("end_date");
      endTimeElement.focus();
    } else if (formik.errors && formik.errors.eventLink) {
      let eventLinkElement = document.getElementById("eventLink");
      eventLinkElement.focus();
    } else if (formik.errors && formik.errors.terms_and_condition) {
      let termAndCondtionsElement = document.getElementById(
        "terms_and_condition"
      );
      termAndCondtionsElement.focus();
    }
  }, [count]);
  return (
    <>
      <React.Fragment>
        {props.mobileButton ? (
          <PopupActionButton
            buttonText={"Edit"}
            buttonType="button"
            buttonClass="smallsave"
            onClick={onOpenModal}
          />
        ) : (
          <div className="enIconBtn mr-3" onClick={onOpenModal}>
            <Image
              src={require("../../../../assets/images/UserManagement/pencil.svg")}
              alt="Edit"
              title="Edit"
              fluid
            />
          </div>
        )}

        <Modal
          open={state.open}
          onClose={onCloseModal}
          center
          classNames={{
            overlay: "customOverlay-request-accept-cancelled",
            modal: "offer-event-main closeRemove",
            animationIn: "customEnterAnimation",
            animationOut: "customLeaveAnimation",
          }}
          animationDuration={1000}
        >
          <div className="d-flex align-items-center py-3 px-4 border-bottom">
            <span className="pr-3 cursor" onClick={onCloseModal}>
              <Image
                alt="Back"
                width="20px"
                src={require("../../../../assets/images/UserManagement/backIcon.svg")}
              />
            </span>
            <div className="f12-400 c_black">Edit Event</div>
          </div>
          <div className="d-flex align-items-start px-3 pt-3">
            <div className={`enAddOffersOPtion `}>
              <Image
                src={require("../../../../assets/images/Menu/vandorGridMenu/2-red.svg")}
                alt="View"
                title="View"
                width="40px"
                height="40px"
                className="ml-3"
              />
              <span className="text-red f12-400 d-block w-100 mb-2 pt-1">
                Online Event
              </span>
              <span className="w-100 f9-400 d-block">
                (Note: these offers can be only be used in your business
                location offline)
              </span>
            </div>
          </div>
          <hr />
          <Form>
            <Row className="pt-4 mx-0">
              <Col lg={8}>
                <Form.Group>
                  <TextField
                    id="name"
                    label="Event Name"
                    type="text"
                    variant="outlined"
                    className={`w-100 ${
                      formik.errors.name && formik.touched.name ? "enError" : ""
                    }`}
                    name="name"
                    onChange={formik.handleChange}
                    value={formik.values.name}
                    onBlur={formik.handleBlur}
                  />
                  {formik.errors.name && formik.touched.name ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.name}
                    </div>
                  ) : null}
                </Form.Group>
                <Form.Group>
                  <TextField
                    id="description"
                    label="Description"
                    type="text"
                    multiline
                    rows="5"
                    variant="outlined"
                    className={`w-100 ${
                      formik.errors.description && formik.touched.description
                        ? "enError"
                        : ""
                    }`}
                    name="description"
                    onChange={formik.handleChange}
                    value={formik.values.description}
                    onBlur={formik.handleBlur}
                  />
                  {formik.errors.description && formik.touched.description ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.description}
                    </div>
                  ) : null}
                </Form.Group>
                <Row className="pb-4">
                  <Col lg={6}>
                    <div className="f12-400 pb-2">
                      (Fill out the details, event are used offline)
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="d-flex align-items-start">
                      <Switch
                        onChange={markAsPrimary}
                        checked={primaryOffer.primaryOffer}
                        offColor="#EEEEEE"
                        onColor="#EEEEEE"
                        offHandleColor="#212121"
                        onHandleColor="#59F832"
                        handleDiameter={24}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        height={15}
                        width={41}
                        boxShadow="-2px 0px 5px #0000003B"
                        activeBoxShadow="-2px 0px 5px #0000003B"
                        id="material-switch"
                      />
                      <div className="pl-2">
                        <div className="f12-500 mb-2">
                          Make this Event Primary
                        </div>
                        <div className="f10-400">
                          (Note you can make only one Offer primary, by making
                          this offer primary it will remove primary from other
                          active offers)
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col lg={12}>
                <hr />

                <div className="f16-500 py-1">Allow Kids?</div>
                <div className="f10-400 pb-4">
                  (This may be relevant if you are a Bar and Night Club with min
                  age to enter, you may still have to check the ID for the
                  entrants)
                </div>
                <Row className="align-items-center pb-3">
                  <Col md={3} xs={6}>
                    <div className="f14-400 text-dark">Kids Allowed</div>
                  </Col>
                  <Col md={9} xs={6}>
                    <div className="d-flex align-items-center">
                      <div className="f12-400 mr-2">No</div>
                      <Toggle
                        checked={checked.checked}
                        toggleFunction={toggleFunction}
                      />
                      <div className="f12-400 ml-2">Yes</div>
                    </div>
                  </Col>
                </Row>
                {checked.checked ? (
                  <Row className="align-items-center pb-3">
                    <Col md={3} xs={6}>
                      <div className="f14-400 text-dark">Min Age for Entry</div>
                    </Col>
                    <Col md={9} xs={6}>
                      <FormControl variant="outlined" className={"w134"}>
                        <Select
                          value={state.minAge}
                          onChange={selecthandleChange}
                          inputProps={{
                            name: "minAge",
                          }}
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          <option value={"18"}>18</option>
                          <option value={"21"}>21</option>
                        </Select>
                      </FormControl>
                    </Col>
                  </Row>
                ) : (
                  <></>
                )}
                <hr className="mb-5" />
                <Row className="align-items-center">
                  <Col md={3} xl={2} xs={6} className="pb-3">
                    <TextField
                      id="start_date"
                      label="Start Date"
                      variant="outlined"
                      InputProps={{
                        inputProps: { min: minDate },
                      }}
                      type="date"
                      defaultValue={minDate}
                      className={`w-100 ${
                        formik.errors.start_date && formik.touched.start_date
                          ? "enError"
                          : ""
                      }`}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      name="start_date"
                      onChange={(e) => handleStartDateChange(e)}
                      //onChange={formik.handleChange}
                      value={formik.values.start_date}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.start_date && formik.touched.start_date ? (
                      <div className="pho_14_regular text-danger">
                        {formik.errors.start_date}
                      </div>
                    ) : null}
                  </Col>
                  <Col md={3} xl={2} xs={6} className="pb-3">
                    <TextField
                      id="start_time"
                      label="Start Time"
                      variant="outlined"
                      type="time"
                      className={`w-100 ${
                        formik.errors.start_time && formik.touched.start_time
                          ? "enError"
                          : ""
                      }`}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      name="start_time"
                      onChange={formik.handleChange}
                      value={formik.values.start_time}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.start_time && formik.touched.start_time ? (
                      <div className="pho_14_regular text-danger">
                        {formik.errors.start_time}
                      </div>
                    ) : null}
                  </Col>
                  <Col md={3} xl={2} xs={6} className="pb-3">
                    <TextField
                      id="end_date"
                      label="End Date"
                      variant="outlined"
                      InputProps={{
                        inputProps: { min: minEndDate },
                      }}
                      type="date"
                      className={`w-100 ${
                        formik.errors.end_date && formik.touched.end_date
                          ? "enError"
                          : ""
                      }`}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      name="end_date"
                      onChange={formik.handleChange}
                      value={formik.values.end_date}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.end_date && formik.touched.end_date ? (
                      <div className="pho_14_regular text-danger">
                        {formik.errors.end_date}
                      </div>
                    ) : null}
                  </Col>
                  <Col md={3} xl={2} xs={6} className="pb-3">
                    <TextField
                      id="end_time"
                      label="End Time"
                      variant="outlined"
                      type="time"
                      className={`w-100 ${
                        formik.errors.end_time && formik.touched.end_time
                          ? "enError"
                          : ""
                      }`}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      name="end_time"
                      onChange={formik.handleChange}
                      value={formik.values.end_time}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.end_time && formik.touched.end_time ? (
                      <div className="pho_14_regular text-danger">
                        {formik.errors.end_time}
                      </div>
                    ) : null}
                  </Col>
                </Row>
                {/* <Row className="pb-4 align-items-center">
              <Col md={4} lg={4}>
                <Form.Group>
                  <TextField
                    label="Coupon Code"
                    type="text"
                    variant="outlined"
                    className="w-100"
                  />
                </Form.Group>
              </Col>
            </Row> */}
                <Row>
                  <Col lg={4} className="pb-4">
                    <Form.Group>
                      <TextField
                        id="eventLink"
                        label="Hyperlink"
                        type="text"
                        variant="outlined"
                        className={`w-100 ${
                          formik.errors.eventLink && formik.touched.eventLink
                            ? "enError"
                            : ""
                        }`}
                        name="eventLink"
                        onChange={formik.handleChange}
                        value={formik.values.eventLink}
                        onBlur={formik.handleBlur}
                      />
                      {formik.errors.eventLink && formik.touched.eventLink ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.eventLink}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                  <Col lg={3} className="pb-4">
                    <Form.Group>
                      <TextField
                        label="Password(if any)"
                        type="text"
                        variant="outlined"
                        className="w-100"
                        name="eventPassword"
                        onChange={formik.handleChange}
                        value={formik.values.eventPassword}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <hr />
                <Form.Group className="py-4">
                  <Form.Label className="f14-500 mb-3">Add Photos</Form.Label>
                  <div className="d-flex flex-wrap">
                    <div className="enUploadBox">
                      <Image
                        src={require("../../../../assets/images/UserManagement/uploadImg.svg")}
                        alt="uploadImg"
                        title="uploadImg"
                        fluid
                      />
                      <input
                        type="file"
                        accept=".png, .jpg, .jpeg"
                        onChange={(e) => uploadImage(e)}
                      />
                    </div>
                    {file && (
                      <div className="enIconUploaded">
                        <button
                          type="button"
                          className="enCloseButton"
                          onClick={() => removeImage()}
                        >
                          <Image
                            src={require("../../../../assets/images/UserManagement/en_close.svg")}
                            alt="uploadImg"
                            title="uploadImg"
                            fluid
                          />
                        </button>
                        <Image
                          src={file}
                          alt="icon"
                          title="icon"
                          className=""
                          fluid
                        />
                      </div>
                    )}
                  </div>
                  <div className="pt-2 f12-400">
                    (You can upload only 1 pic per offer 700 x 420 pixels)
                  </div>
                </Form.Group>
                <Form.Group className="pb-4">
                  <Form.Label className="f14-500 mb-3">Add Video</Form.Label>
                  <div className="d-flex flex-wrap">
                    <div className="enUploadBox">
                      <Image
                        src={require("../../../../assets/images/UserManagement/uploadImg.svg")}
                        alt="uploadImg"
                        title="uploadImg"
                        fluid
                      />
                      <input type="file" accept=".mp4" onChange={uploadVideo} />
                    </div>
                    {Video && (
                      <div className="enIconUploaded">
                        <button
                          type="button"
                          className="enCloseButton"
                          onClick={() => removeVideo()}
                        >
                          <Image
                            src={require("../../../../assets/images/UserManagement/en_close.svg")}
                            alt="uploadImg"
                            title="uploadImg"
                            fluid
                          />
                        </button>
                        <video
                          width="100%"
                          height="100%"
                          controls
                          src={Video}
                          type="video/mp4"
                        />
                      </div>
                    )}
                  </div>
                  <div className="pt-2 f12-400">
                    (You can upload only 1 pic per offer 700 x 420 pixels)
                  </div>
                </Form.Group>
                <Row>
                  <Col lg={8}>
                    <Form.Group>
                      <TextField
                        id="terms_and_condition"
                        label="Terms and Conditions"
                        type="text"
                        multiline
                        rows="5"
                        variant="outlined"
                        className={`w-100 ${
                          formik.errors.terms_and_condition &&
                          formik.touched.terms_and_condition
                            ? "enError"
                            : ""
                        }`}
                        name="terms_and_condition"
                        onChange={formik.handleChange}
                        value={formik.values.terms_and_condition}
                        onBlur={formik.handleBlur}
                      />
                      {formik.errors.terms_and_condition &&
                      formik.touched.terms_and_condition ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.terms_and_condition}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                </Row>
                <div className="py-4 d-flex align-items-center">
                  <Button
                    variant="outline-secondary"
                    className="btn-lg mr-4 px-5 btn150px"
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="danger"
                    className="btn-lg px-5 btn150px"
                    onClick={() => onClickSave()}
                  >
                    Save
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </Modal>
      </React.Fragment>
    </>
  );
};

MobileVendorEditOnlineEvent.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, null)(MobileVendorEditOnlineEvent);
